import { render } from "./yapilacakForm.vue?vue&type=template&id=476735c6&scoped=true"
import script from "./yapilacakForm.vue?vue&type=script&lang=js"
export * from "./yapilacakForm.vue?vue&type=script&lang=js"

import "./yapilacakForm.vue?vue&type=style&index=0&id=476735c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476735c6"]])

export default __exports__